import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  InputBase,
  Pagination,
  Menu,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExportDropdown from "../../../components/ExportDropdown";
import StatusDropdown from "../../../components/StatusDropdown";
import { showUnderDevelopment } from "../../../components/alerts";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../../components/BaseUrl";
import { decryptToken } from "../../../Utlis/Encryption";
import TruncatedCell from "../../../components/TruncatedCell";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import emptyscreen from "../../../assets/Dashboard/emptyscreen.svg";
import CustomText, { textStyles } from "../../../components/CustomText";
import mapicon from "../../../assets/Dashboard/mapicon.svg";
import { useNavigate } from "react-router-dom";
const MonthlySummary = () => {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
const navigate=useNavigate()
  // Drawer + menu state
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
  const [selectedMonth, setSelectedMonth] = useState(dayjs());


  const [allRows, setAllRows] = useState([]);
useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      const monthParam = selectedMonth.format("YYYY-MM");
      const res = await fetch(
        `${BASE_URL}/attendance/monthly?month=${monthParam}&search=${searchQuery}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await res.json();
      console.log("monthly data is", data);

      if (!data.error) {
        const formatted = (data.data.records || []).map((item, idx) => ({
          id: idx + 1, // keep continuous numbering
          date: new Date(item.date).toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          }),
          checkIn: item.first_check_in || "-",
          checkOut: item.last_check_out || "-",
          location:
            item.punches?.[0]?.location?.gps_latitude &&
            item.punches?.[0]?.location?.gps_longitude
              ? `${item.punches[0].location.gps_latitude}, ${item.punches[0].location.gps_longitude}`
              : "-",
          details: item.status || "-",
          status: item.status,
          raw: item,
          punchIds: (item.punches || []).map((p) => p.id),
        }));

        // Save all rows
        setAllRows(formatted);

        // Reset page to 1 whenever data reloads
        setPage(1);
      }
    } catch (err) {
      console.error("Error fetching monthly attendance", err);
    } finally {
      setLoading(false);
    }
  };

  if (token) fetchData();
}, [token, selectedMonth, searchQuery]);
useEffect(() => {
  const startIdx = (page - 1) * 5;
  const endIdx = startIdx + 5;
  setRows(allRows.slice(startIdx, endIdx));
  setTotalPages(Math.ceil(allRows.length / 5) || 1);
}, [allRows, page]);



  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => setAnchorEl(null);

  const handleViewClick = () => {
    console.log("Selected punch IDs:", selectedRow?.punchIds);
    setDrawerOpen(true);
    handleMenuClose();
  };

  const HaederStyles = {
    color: "#44546F",
    fontSize: "14px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };
  const DataStyles = {
    color: "#172B4D",
    fontSize: "12px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 400,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const handleIcon = () => {
    navigate("/monthly-summary", { state: { fromDashboard: true } });
}
  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: "white",
        borderRadius: 2,
    border: "2px solid #091E4224",
      }}
    >
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography sx={{ fontWeight: 600, fontSize: 16, fontFamily: "Poppins, sans-serif" }}>
          {t("monthlySummary.title")}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* Search */}
          <Box
            sx={{
              px: 0.5,
              py: 0.2,
              borderRadius: 1,
              height: 34,
              border: "2px solid #091E4224",
              display: "flex",
              alignItems: "center",
              minWidth: 250,
            }}
          >
            <InputBase
              placeholder={t("monthlySummary.searchPlaceholder")}
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setPage(1);
              }}
              sx={{
                ml: 0.5,
                fontSize: 15,
                fontFamily: "Poppins, sans-serif",
                color: "#939393",
                width: "100%",
              }}
            />
            <SearchIcon sx={{ fontSize: 22, color: "#888", mr: 0.5 }} />
          </Box>
             {/* Export & Filter */}
      
          {/* Month Select */}
       <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
    views={["year", "month"]}
    value={selectedMonth}
    onChange={(newValue) => {
      setSelectedMonth(newValue);
      setPage(1); // reset to page 1 when month changes
    }}
  enableAccessibleFieldDOMStructure={false}
    maxDate={dayjs()} 
  slotProps={{
    textField: {
      size: "small",
      sx: {
        "& .MuiInputBase-root": {
          height: 34,
          fontSize: "14px",
        },
        "& .MuiInputBase-input": {
          padding: "2px 6px",
          fontSize: "14px",
        },
        "& .MuiSvgIcon-root": {
          fontSize: "16px",
        },
      },
    },
    popper: {
      sx: {
        "& .MuiPickersCalendarHeader-label": {
          fontSize: "14px", // shrink Month-Year label
          fontWeight: 500,
        },
        "& .MuiPickersCalendarHeader-switchViewButton": {
          fontSize: "12px", // shrink dropdown button
        },
        "& .MuiPickersArrowSwitcher-button": {
          fontSize: "12px", // shrink arrow buttons
        },
        "& .MuiDayCalendar-weekDayLabel": {
          fontSize: "14px", // week day letters (S M T W T F S)
        },
        "& .MuiPickersDay-root": {
          fontSize: "14px", // dates inside the grid
          width: 28,        // shrink day cell width
          height: 28,       // shrink day cell height
          margin: 1,
        },
      },
    },
  }}
  />
</LocalizationProvider>
  <Box sx={{ display: "flex", flexDirection:"row",alignItems: "center", gap: 1 }}> 
         
    <IconButton>
            <img
              src={mapicon}
              onClick={handleIcon}
              alt="map"
              style={{ width: 33, height: 33 }}
            />
          </IconButton>
        </Box>
        </Box>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={HaederStyles}>{t("monthlySummary.columns.id")}</TableCell>
              <TableCell sx={HaederStyles}>{t("monthlySummary.columns.date")}</TableCell>
              <TableCell sx={HaederStyles}>{t("monthlySummary.columns.checkIn")}</TableCell>
              <TableCell sx={HaederStyles}>{t("monthlySummary.columns.checkOut")}</TableCell>
              <TableCell sx={HaederStyles}>{t("monthlySummary.columns.location")}</TableCell>
              <TableCell sx={HaederStyles}>{t("monthlySummary.columns.details")}</TableCell>
              <TableCell sx={HaederStyles}>{t("monthlySummary.columns.status")}</TableCell>
            
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  <CircularProgress size={22} />
                </TableCell>
              </TableRow>
            ) : rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9}>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", alignItems: "center", height: 300 }}
                  >
                    <img src={emptyscreen} alt="No Data" style={{ width: 200 }} />
                    <CustomText sx={{ ...textStyles.h1, fontSize: "16px", color: "#003149", pt: 1 }}>
                      {t("empty.no_user")}
                    </CustomText>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, index) => (
                <TableRow key={index} hover>
                  <TableCell sx={DataStyles}>{row.id}</TableCell>
                  <TableCell sx={DataStyles}>{row.date}</TableCell>
                  <TableCell sx={DataStyles}>{row.checkIn}</TableCell>
                  <TableCell sx={DataStyles}>{row.checkOut}</TableCell>
                  <TableCell sx={DataStyles}>
                    <TruncatedCell text={row.location} />
                  </TableCell>
                  <TableCell sx={DataStyles}>
                    <TruncatedCell text={row.details} />
                  </TableCell>
                  <TableCell>
                    <Box sx={{ pointerEvents: "none" }}>
                      <StatusDropdown currentStatus={row.status} />
                    </Box>
                  </TableCell>
            
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Pagination
           count={totalPages}
  page={page}
  onChange={(e, value) => setPage(value)}
          shape="rounded"
          color="primary"
          size="small"
        />
      </Box>


 
    </Box>
  );
};

export default MonthlySummary;